import { Constants, SaleNoteStatusSkuReport } from "../../../../../core";

export const saleNoteStatusSkuReport = {
    searchText: '',
    addText: '',
    checkbox: false,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    selectedRow: true,
    columns: [
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.skuPartialSequence !== undefined ?  element.skuCode + '-'+ element.skuPartialSequence.toString() :element.skuCode
      },
       {
        title: 'Cantidad solicitada',
        name: 'requestAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.processedAmount != null && element.pendingAmount != null?
                                                     parseFloat(element.processedAmount) + parseFloat(element.pendingAmount) : element.units
      },
      {
        title: 'Cantidad entregada',
        name: 'deliveryAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.processedAmount
      },
      {
        title: 'Descripción de SKU',
        name: 'skuName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.skuName.replace('�', '')
      },
      {
        title: 'Dirección de destino',
        name: 'destinationAddress',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.destinyAddress
      },
      {
        title: 'Estados del despacho',
        name: 'skuState',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.state.stateName
      },
      /* {
        title: 'Fecha de estimada de entrega',
        name: 'estimatedDeliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.estimatedDeliveryDate
      }, */
      {
        title: 'Fecha real de entrega',
        name: 'actualDeliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => element.dispatchDate ? element.dispatchDate :
        (element.dispatchHistory ? element.dispatchHistory.deliveredDate : '')
      },
      {
        title: 'Modificar',
        name: 'view',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => {
          return {
            icon: 'edit',
            value: 'Modificar despacho',
            style: 'recordColumn icon-table',
            disabled: element.productType !== 'ST' ||
              (element.division && element.division === Constants.Dispatch.FOOD) ||
              (element.state.stateName === "Cancelado" ||
              element.state.stateName === "Pre-Cancelado" ||
              element.state.stateName === "Entregado al cliente" ||
              element.state.stateName === "Entregado")
          };
        }
      },
      {
        title: 'Historial',
        name: 'history',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusSkuReport) => {
          return {
            data: element.saleNoteTransaction,
            icon: 'playlist_add_check',
            tooltip: 'Ver historial',
            class: ' recordColumn icon-table',
            disabled: element.saleNoteTransaction.length === 0
          };
        }
      }
    ]
  }
